export default __webpack_public_path__ + "static/media/home.534924b4.jpg";